var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: { inline: true, model: _vm.searchForm, size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入订单编号", clearable: "" },
                        model: {
                          value: _vm.searchForm.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderNo", $$v)
                          },
                          expression: "searchForm.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "下单用户", prop: "userInfo" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入下单用户", clearable: "" },
                        model: {
                          value: _vm.searchForm.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "username", $$v)
                          },
                          expression: "searchForm.username",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "业绩类型", prop: "brandId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: {
                            placeholder: "请选择业绩类型",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "type", $$v)
                            },
                            expression: "searchForm.type",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "订单业绩", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "会员业绩", value: "2" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "订单时间", prop: "lastActiveTimeStart" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "232px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.value1,
                          callback: function ($$v) {
                            _vm.value1 = $$v
                          },
                          expression: "value1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "form-btn" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [
          _c("h3", [_vm._v("列表数据")]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.exporting,
                    icon: "el-icon-upload2",
                  },
                  on: { click: _vm.exportFn },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.page.pageNo,
                "page-size": _vm.page.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "pageNo", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "pageNo", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }